<template>
  <scroll-bar>
    <div :class="['sidebar-brand', { 'is-collapse': isCollapse }]" @click="openHome">
      <template v-if="isCollapse">
        <span class="brand-collapsed">H</span>
      </template>
      <template v-else>
        <span class="brand-main">
          <img src="@/assets/logo/hurixWhite2.png" alt="logo" />
        </span>
        <span class="brand-sub">{{ brandSubtitle }}</span>
      </template>
    </div>
    <el-menu
        ref="menu"
        mode="vertical"
        :show-timeout="200"
        :default-active="$route.path"
        :collapse="isCollapse"
        :default-openeds="defaultOpeneds"
        :collapse-transition="false"
        :background-color="'#203245'"
        :text-color="'#A8B5C4'"
        :active-text-color="'#F97316'"
    >
      <router-link :to="'/home'" :key="'home'">
        <el-menu-item
          :index="'/home'"
          :class="['sidebar-home-item', { 'is-home-active': checkIfHome }]"
          @click="resetPageCache('home')"
          v-debounce
        >
          <i class="fi-sr-dashboard home-icon"></i>
          <span slot="title">{{ $t('system.home') }}</span>
        </el-menu-item>
      </router-link>

      <sidebar-item
          v-for="(route, index) in routers"
          :isCollapse="isCollapse"
          :key="route.path  + index"
          :item="route"
          :base-path="route.path"
      />
    </el-menu>
  </scroll-bar>
</template>

<script>
import {mapGetters} from 'vuex'
import SidebarItem from './SidebarItem'
import ScrollBar from '@/components/ScrollBar'
import {clearScrollPositions, setNavigationSource} from '@/utils/pageNavigation'

export default {
  components: {SidebarItem, ScrollBar},
  computed: {
    ...mapGetters([
      'sidebar',
      'routers'
    ]),
    isCollapse() {
      return !this.sidebar.opened
    },
    defaultOpeneds() {
      return this.routers
        .filter(item => !item.hidden && item.children && item.children.some(child => !child.hidden))
        .map(item => item.name || item.path)
    },
    brandSubtitle() {
      return this.$i18n.locale === 'zh'
        ? `${this.$t('system.systemName')} · 管理端`
        : `${this.$t('system.systemName')} · Admin`
    },
    // 检查当前路由是否在Home页
    checkIfHome() {
      return this.$route.path === '/home'
    }
  },
  watch: {
    'sidebar.opened'(opened) {
      if (opened) {
        this.openAllMenus()
      }
    }
  },
  created() {
    console.log(this.routers,"routers")
  },
  methods: {
    resetPageCache(routeName) {
      clearScrollPositions()
      if (routeName !== this.$route.name) setNavigationSource('menu')
      this.$store.commit('RESET_PAGE_CACHE', routeName)
    },
    openHome() {
      this.resetPageCache('home')
      this.$router.push('/home')
    },
    openAllMenus() {
      this.$nextTick(() => {
        const menu = this.$refs.menu
        if (!menu || this.isCollapse) return
        this.routers
          .filter(item => !item.hidden && item.children && item.children.some(child => !child.hidden))
          .forEach(item => menu.open(item.name || item.path))
      })
    }
  }
}
</script>
<style lang="scss" scoped>
//.scroll-container {
//  font-family: 'Roboto', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, 'PingFang SC', 'Microsoft YaHei', sans-serif;
//}

.home-icon{
  color: #6b7d94;
}
#app .sidebar-container .el-menu-item .home-icon {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 16px;
  height: 16px;
  margin-right: 10px;
  font-size: 18px !important;
  line-height: 1;
  vertical-align: sub;
}

/deep/ .el-submenu__title,
/deep/ .el-submenu__title:hover {
  background-color: transparent !important;
}
.sidebar-brand {
  display: flex;
  flex-direction: column;
  justify-content: space-evenly;
  min-height: 64px;
  padding: 0 20px;
  border-bottom: 1px solid #2a3a4f;
  cursor: pointer;

  &.is-collapse {
    align-items: center;
    padding: 0;
  }

  .brand-main {
    display: block;
    color: #ffffff;
    font-size: 18px;
    font-weight: 700;
    padding: 10px 0 5px 0;
    line-height: 1.2;
    letter-spacing: 0.04em;
    img {
      width: 86px;
    }
  }

  .brand-sub {
    display: block;
    margin-top: 4px;
    color: #8b99a9;
    font-size: 10px;
    line-height: 1.2;
    letter-spacing: 0.12em;
  }

  .brand-collapsed {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 36px;
    height: 36px;
    border-radius: 10px;
    background: rgba(249, 115, 22, 0.18);
    color: #f97316;
    font-size: 16px;
    font-weight: 700;
  }
}

</style>



// WEBPACK FOOTER //
// src/views/layout/components/Sidebar/index.vue